// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__sOUrL","isCelebrating":"style_isCelebrating__2NwUD","icon":"style_icon__3dib5"};